
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { PageLoading } from "@/components/shared/PageLoading";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

// Lazy loaded pages
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminLayout = lazy(() => import("@/components/admin/AdminLayout"));
const Dashboard = lazy(() => import("@/pages/admin/Dashboard"));
const UserManagement = lazy(() => import("@/pages/admin/UserManagement"));
const SessionManagement = lazy(() => import("@/pages/admin/SessionManagement"));
const AnalyticsPage = lazy(() => import("@/pages/admin/AnalyticsPage"));
const Communications = lazy(() => import("@/pages/admin/Communications"));
const Settings = lazy(() => import("@/pages/admin/Settings"));
const ImportTherapists = lazy(() => import("@/pages/admin/ImportTherapists"));
const TherapistsList = lazy(() => import("@/pages/admin/TherapistsList"));
const ImportJobs = lazy(() => import("@/pages/admin/ImportJobs"));
const TranslationAssistant = lazy(() => import("@/pages/admin/TranslationAssistant"));
const CityTranslationsTest = lazy(() => import("@/pages/admin/CityTranslationsTest"));

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={
        <Suspense fallback={<PageLoading />}>
          <AdminLogin />
        </Suspense>
      } />
      
      <Route element={
        <ProtectedRoute requiredRole="admin">
          <Suspense fallback={<PageLoading />}>
            <AdminLayout />
          </Suspense>
        </ProtectedRoute>
      }>
        <Route index element={
          <Suspense fallback={<PageLoading />}>
            <Dashboard />
          </Suspense>
        } />
        <Route path="dashboard" element={
          <Suspense fallback={<PageLoading />}>
            <Dashboard />
          </Suspense>
        } />
        <Route path="import" element={
          <Suspense fallback={<PageLoading />}>
            <ImportTherapists />
          </Suspense>
        } />
        <Route path="therapists" element={
          <Suspense fallback={<PageLoading />}>
            <TherapistsList />
          </Suspense>
        } />
        <Route path="import-jobs" element={
          <Suspense fallback={<PageLoading />}>
            <ImportJobs />
          </Suspense>
        } />
        <Route path="users" element={
          <Suspense fallback={<PageLoading />}>
            <UserManagement />
          </Suspense>
        } />
        <Route path="sessions" element={
          <Suspense fallback={<PageLoading />}>
            <SessionManagement />
          </Suspense>
        } />
        <Route path="analytics" element={
          <Suspense fallback={<PageLoading />}>
            <AnalyticsPage />
          </Suspense>
        } />
        <Route path="communications" element={
          <Suspense fallback={<PageLoading />}>
            <Communications />
          </Suspense>
        } />
        <Route path="settings" element={
          <Suspense fallback={<PageLoading />}>
            <Settings />
          </Suspense>
        } />
        <Route path="translations" element={
          <Suspense fallback={<PageLoading />}>
            <TranslationAssistant />
          </Suspense>
        } />
        <Route path="city-translations-test" element={
          <Suspense fallback={<PageLoading />}>
            <CityTranslationsTest />
          </Suspense>
        } />
        <Route path="approvals" element={
          <Suspense fallback={<PageLoading />}>
            <UserManagement />
          </Suspense>
        } />
        <Route path="financials" element={
          <Suspense fallback={<PageLoading />}>
            <SessionManagement />
          </Suspense>
        } />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;